function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.707078 7.7783C1.0976 8.16882 1.73077 8.16882 2.12129 7.7783L7.07104 2.82855C7.85209 2.0475 7.85209 0.781171 7.07104 0.00012207L0.707078 6.36408C0.316554 6.75461 0.316553 7.38777 0.707078 7.7783Z",
  fill: "#9FAFB9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.4349 7.7782C13.8254 7.38768 13.8254 6.75451 13.4349 6.36399L7.07104 0.00012207C6.28999 0.781171 6.28999 2.0475 7.07104 2.82855L12.0206 7.7782C12.4112 8.16873 13.0443 8.16873 13.4349 7.7782Z",
  fill: "#9FAFB9"
});

var SvgTxCollapse = function SvgTxCollapse(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTxCollapse, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tx-collapse.7048a236.svg";
export { ForwardRef as ReactComponent };